import { getMarketHours } from '@terminal/components/price-display-view/helpers/price-display-helpers';

export const getTimezoneAbbreviation = (date: string): string => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZoneName =
    new Intl.DateTimeFormat('en-US', {
      timeZone: userTimezone,
      timeZoneName: 'short',
    })
      .formatToParts(new Date(date))
      .find(part => part.type === 'timeZoneName')?.value ?? '';
  return timeZoneName;
};

export const getMarketSessionLabelKey = (): string => {
  const { isPreMarket, isAfterMarket } = getMarketHours();
  if (isPreMarket) return 'watchlistManager:priceCell.preMarket';
  if (isAfterMarket) return 'watchlistManager:priceCell.afterHours';
  return 'watchlistManager:priceCell.marketOpen';
};
